import React from 'react';

import { invoiceDate } from '@adjust/dashboard-core/lib/format/dateTime';

interface CurrentChargeProps {
  begin: string;
  end: string;
  totalPriceNet: string;
}

const CurrentCharge: React.FC<CurrentChargeProps> = ({ begin, end, totalPriceNet }) => (
  <div className="your-data-invoice your-data-invoice--current">
    <div className="your-data-invoice__date">
      {invoiceDate(begin)}
      {' - '}
      {invoiceDate(end)}
    </div>
    <div className="your-data-invoice__price">{totalPriceNet}</div>
    <div className="your-data-invoice__status">
      <div className="your-data-invoice__status-label your-data-invoice__status-label--current">
        {t('invoice.status.current')}
      </div>
    </div>
  </div>
);

export default CurrentCharge;
